import { useState, useRef, useEffect } from "react";
/** Hover/tooltip/citation-card domain: event hover state, tooltip position, stuck-tooltip safety net, citation card. */
export function useHoverTooltip() {
  const [hov, setHov] = useState(null);
  const [hoveredBranch, setHoveredBranch] = useState(null);
  const [hoveredBranchTrigger, setHoveredBranchTrigger] = useState(null);
  // Which OUTCOME row of the distribution marker the cursor is on, by label — the
  // probability plot traces that outcome's own history while it is set, and falls back
  // to the leading outcome when it is null. A label rather than an index: bucket order
  // is display order and a nominal categorical is ranked by probability, so an index
  // addresses a different outcome from one forecast to the next.
  const [hoveredBin, setHoveredBin] = useState(null);
  const hovEvtRef = useRef(null);
  const longPressRef = useRef({ timer: null, fired: false, evId: null });
  const [hovPos, setHovPos] = useState({ x: 0, y: 0 });
  // Report citation hover card: {label, quotes, url, x, y} or null. Anchored at
  // the hovered or keyboard-focused Why Yes / Why No citation link (see CitationCard).
  const [citCard, setCitCard] = useState(null);
  // Mirror hovPos into a ref so the safety-net mousemove listener (below) can
  // read the latest position without re-binding on every cursor move.
  const hovPosRef = useRef({ x: 0, y: 0 });
  useEffect(() => {
    hovPosRef.current = hovPos;
  }, [hovPos]);
  // Safety net for "stuck tooltip": if a hovered event's halo unmounts
  // (e.g. it scrolls off-screen during a pan/zoom), onMouseLeave never fires
  // and `hov` stays set. Watch global mousemove while hov is active and clear
  // it once the cursor wanders >100px from the last halo-tracked position.
  useEffect(() => {
    if (!hov) return;
    const onMove = (e) => {
      const dx = e.clientX - hovPosRef.current.x;
      const dy = e.clientY - hovPosRef.current.y;
      if (Math.abs(dx) > 100 || Math.abs(dy) > 100) {
        setHov(null);
        hovEvtRef.current = null;
      }
    };
    window.addEventListener("mousemove", onMove);
    return () => window.removeEventListener("mousemove", onMove);
  }, [hov]);
  return {
    hov,
    setHov,
    hoveredBranch,
    setHoveredBranch,
    hoveredBranchTrigger,
    setHoveredBranchTrigger,
    hoveredBin,
    setHoveredBin,
    hovPos,
    setHovPos,
    citCard,
    setCitCard,
    hovEvtRef,
    longPressRef,
    // hovPosRef is internal to the safety-net effect; not returned.
  };
}
